var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white text-gray-900 shadow-2xl",class:{ 'border-t-4 border-red-500': !_vm.hasCounter }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }